// extracted by mini-css-extract-plugin
export default {"icoWrapper":"icoWrapper---ekKUM"};